export function getSlideId() {
  var id = window.tnsId;
  window.tnsId = !id ? 1 : id + 1;
  
  return 'tns' + window.tnsId;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/getSlideId.js
// module id = 70
// module chunks = 0